export default (builtDate: number, renovationDate: number): string => {
    if (builtDate && !renovationDate) return `Год открытия: ${builtDate}`;
    if (renovationDate) return `Год реновации: ${renovationDate}`;
    return '';
};